// extracted by mini-css-extract-plugin
module.exports = {"plate":"AttentionPlate_plate__dztYH"};